import config from "../config.json";

export function getFullLandingPageUrl(landingPageUrl, slug) {
    return `${config.marketingBaseUrl}/${landingPageUrl}/${slug}`;
}
